export default class Share {
  constructor() {
    this.$links = document.querySelectorAll('.c-share__link');
    if (!this.$links.length) return;
    this.$links.forEach(link => this.setupLink(link));
  }

  setupLink(link) {
    const { network, title } = link.dataset;
    const { href } = window.location;

    if (network !== 'email') {
      link.addEventListener('click', this.constructor.onClick.bind(this));
      link.setAttribute('target', '_blank');
    }

    switch (network) {
      case 'facebook':
        link.setAttribute('href', `https://www.facebook.com/sharer/sharer.php?u=${href}`);
        break;
      case 'twitter':
        link.setAttribute('href', `http://twitter.com/share?url=${href}`);
        break;
      case 'linkedin':
        link.setAttribute('href', `https://www.linkedin.com/shareArticle?url=${href}`);
        break;
      case 'email':
        link.setAttribute('href', `mailto:?subject=${title}&body=${href}`);
        break;

      default: break;
    }
  }

  static onClick(e) {
    e.preventDefault();

    const width = 600;
    const height = 400;
    const left = (window.screen.width / 2) - (width / 2);
    const top = (window.screen.height / 2) - (height / 2);

    window.open(e.currentTarget.href, 'targetWindow', `scrollbars=yes,resizable=yes,width=${width},height=${height},top=${top},left=${left}`);
  }
}
